/**
 * Faulted Device Constants
 *
 * A device is faulted when its animatic's active state has the typed `faulted`
 * status. Whether it can be reset, and what a reset writes, come from the Reset
 * Fault action: action-component states whose `stateName` starts with one of these
 * prefixes followed by the device alias (see
 * `bff/domains/shared/action-components/action-components.go`).
 */

/** State-name prefixes of the Reset Fault action states. */
export const RESET_FAULT_STATE_PREFIXES = {
  /** Faulted and resettable; the reset dialog asks for the mode to run in afterwards. */
  DROPDOWN: 'reset-fault-dropdown-',
  /** Faulted and resettable; the device has no mode, so the reset writes only the fault reset. */
  MODELESS: 'reset-fault-modeless-button-',
  /** Faulted but not resettable until system conditions are met. */
  DISABLED: 'reset-fault-disabled-',
} as const;

/** Fallback reason shown when a faulted device cannot be reset and the BFF sends no message. */
export const DEFAULT_RESET_FAULT_DISABLED_MESSAGE =
  'The fault cannot be reset until system conditions are met.';

/** Reason shown for a faulted device that has no active Reset Fault action. */
export const NO_RESET_FAULT_ACTION_MESSAGE = 'This device has no Reset Fault action.';

/** Empty state of the Faulted tab and the Reset Faulted view once nothing is faulted. */
export const NO_FAULTED_EQUIPMENT = {
  message: 'No faulted equipment',
  subtext: 'Every device is running without a fault.',
} as const;
